import * as React from 'react';
import GET_CANCELLATION_REASON from 'coaching/queries/GetCancellationReasons.gql';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import { GetCancellationReasons } from 'coaching/queries/__generated__/GetCancellationReasons';

export type Props = {
  children: (props: {
    cancellationReasons: string[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCancellationReasonsContainer(props: Props) {
  return (
    <Query<GetCancellationReasons> query={GET_CANCELLATION_REASON}>
      {({ loading, error, data }) => {
        return props.children({
          cancellationReasons: data?.coaching?.getCancellationReasons?.cancellationReasons ?? [],
          loading,
          error,
        });
      }}
    </Query>
  );
}
